import produce from "immer";
import { SequenceContactListsActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialSequenceContactListsState } from "./sequenceContactLists.types";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_CONTACT_LIST_DETAIL,
  CLEAR_SEQUENCE_CONTACT_LISTS_STATE,
  FETCH_CONTACTS_FAILED,
  FETCH_CONTACTS_PROGRESS,
  FETCH_CONTACTS_SUCCESS,
  FETCH_CONTACT_LISTS_FAILED,
  FETCH_CONTACT_LISTS_PROGRESS,
  FETCH_CONTACT_LISTS_SUCCESS,
  FETCH_CONTACT_LIST_FAILED,
  FETCH_CONTACT_LIST_PROGRESS,
  FETCH_CONTACT_LIST_SUCCESS,
} from "./sequenceContactListsActions";

export const sequenceContactListsReducer = (
  state: IStoreState["sequenceContactLists"] = initialSequenceContactListsState,
  action: SequenceContactListsActions
) => {
  switch (action.type) {
    // ---- Contact lists table ---------------------------------------------
    case FETCH_CONTACT_LISTS_PROGRESS:
      return produce(state, (draft) => {
        draft.listsLoading = LoadState.InProgress;
        draft.lists = [];
      });
    case FETCH_CONTACT_LISTS_SUCCESS:
      return produce(state, (draft) => {
        draft.listsLoading = LoadState.Loaded;
        draft.lists = action.payload.data;
        draft.listsTotalRecords = action.payload.totalRecords;
      });
    case FETCH_CONTACT_LISTS_FAILED:
      return produce(state, (draft) => {
        draft.listsLoading = LoadState.Failed;
        draft.lists = [];
      });

    // ---- Single list (detail header) -------------------------------------
    case FETCH_CONTACT_LIST_PROGRESS:
      return produce(state, (draft) => {
        draft.listLoading = LoadState.InProgress;
      });
    case FETCH_CONTACT_LIST_SUCCESS:
      return produce(state, (draft) => {
        draft.listLoading = LoadState.Loaded;
        draft.list = action.payload.data;
      });
    case FETCH_CONTACT_LIST_FAILED:
      return produce(state, (draft) => {
        draft.listLoading = LoadState.Failed;
      });

    // ---- Contacts --------------------------------------------------------
    case FETCH_CONTACTS_PROGRESS:
      return produce(state, (draft) => {
        draft.contactsLoading = LoadState.InProgress;
        draft.contacts = [];
      });
    case FETCH_CONTACTS_SUCCESS:
      return produce(state, (draft) => {
        draft.contactsLoading = LoadState.Loaded;
        draft.contacts = action.payload.data;
        draft.contactsTotalRecords = action.payload.totalRecords;
      });
    case FETCH_CONTACTS_FAILED:
      return produce(state, (draft) => {
        draft.contactsLoading = LoadState.Failed;
        draft.contacts = [];
      });

    // ---- Clear -----------------------------------------------------------
    case CLEAR_CONTACT_LIST_DETAIL:
      return produce(state, (draft) => {
        draft.list = null;
        draft.listLoading = LoadState.NotLoaded;
        draft.contacts = [];
        draft.contactsLoading = LoadState.NotLoaded;
        draft.contactsTotalRecords = 0;
      });
    case CLEAR_SEQUENCE_CONTACT_LISTS_STATE:
      return initialSequenceContactListsState;

    default:
      return state;
  }
};
